var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isEmptyData
    ? _c("v-client-table", {
        ref: "consentTable",
        staticClass: "w-100 vue-custom-table no-pagination disclaimers-table",
        attrs: {
          id: "consent-table-id",
          data: _vm.consentRequests,
          columns: _vm.columns,
          options: _vm.options,
          name: "consentRequestsTable",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "enabled",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("div", { staticClass: "form-group-checkbox" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pretty p-icon p-jelly p-smooth p-curve mr-0",
                      },
                      [
                        _c("input", {
                          staticClass: "checkbox",
                          attrs: {
                            id: "consent-enabled-" + row.id,
                            type: "checkbox",
                          },
                          domProps: { checked: row.enabled },
                          on: {
                            change: function ($event) {
                              return _vm.toggleConsentEnabled(row)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "state p-success" }, [
                          _c("i", { staticClass: "icon fa fa-check" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { attrs: { for: "consent-enabled-" + row.id } },
                            [
                              _c("span", { staticStyle: { display: "none" } }, [
                                _vm._v("Success"),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              },
            },
            {
              key: "message",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("pre", { staticClass: "my-2" }, [
                    _vm._v("      " + _vm._s(row.description) + "\n    "),
                  ]),
                ]
              },
            },
            {
              key: "document",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "a",
                    {
                      staticClass: "text-primary clickable",
                      on: {
                        click: function ($event) {
                          return _vm.showPreviewer(row)
                        },
                      },
                    },
                    [_vm._v("\n      " + _vm._s(row.fileName) + "\n    ")]
                  ),
                ]
              },
            },
            {
              key: "actions",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "btn request-from-type clickable text-primary bold text-capitalize",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("edit-disclaimer", row)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("global.words.edit")) +
                              "\n      "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("inline-prompt", {
                        ref: "prompt",
                        staticClass: "d-inline-block bold text-gray ml-2",
                        attrs: {
                          "action-type": "delete",
                          placement: "left",
                          "confirmation-text": _vm.$t(
                            "global.messages.deleteConfirmation",
                            {
                              item: _vm.$t(
                                "settings.disclaimers.consentRequest"
                              ),
                            }
                          ),
                        },
                        on: {
                          accept: function ($event) {
                            return _vm.handleRemove(row)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ],
          null,
          false,
          1275645097
        ),
      })
    : _c(
        "div",
        { staticClass: "d-flex flex-column align-items-center w-100" },
        [
          _c(
            "no-results",
            {
              attrs: {
                "img-src": require("@Shared/@Assets/img/application-missing.png"),
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t("settings.disclaimers.thereAreNoConsentForms")
                  ) +
                  "\n  "
              ),
            ]
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }